// components/paginationcontrols.jsx
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../styles/index.css';

const PaginationControls = ({
  totalItems,
  rowsPerPage,
  currentPage,
  onPageChange,
  onRowsPerPageChange,
  isCollapsed = false
}) => {
  const totalPages = Math.ceil(totalItems / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;

  return (
    <div className="pagination-info">
      <div className="rows-per-page">
        <span>Rows per page:</span>
        <select
          value={rowsPerPage}
          onChange={(e) => {
            onRowsPerPageChange(Number(e.target.value));
            onPageChange(1); // Reset to page 1 when changing rows
          }}
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      <div className="page-info-user">
        {startIndex + 1}–{Math.min(startIndex + rowsPerPage, totalItems)} of {totalItems}
      </div>

      <div
        className={`pagination-buttons ${isCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}
        style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
      >
        <button
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          style={{
            background: 'none',
            border: 'none',
            cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
            color: currentPage === 1 ? '#ccc' : '#000',
            padding: '4px'
          }}
        >
          <ChevronLeft size={16.5} />
        </button>

        <button
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage === totalPages}
          style={{
            background: 'none',
            border: 'none',
            cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
            color: currentPage === totalPages ? '#ccc' : '#000',
            padding: '4px'
          }}
        >
          <ChevronRight size={16.5} />
        </button>
      </div>
    </div>
  );
};

export default PaginationControls;
